module.exports = __webpack_public_path__ + "static/media/interrogative_and_indefinite_pronouns1_img.2573f328.JPG";